import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        username: '',
        userlv: '0'
    },
    mutations: {
        username(state, username) {
            state.username = username
        },
        userlv(state, userlv) {
            state.userlv = userlv
        }
    },
    actions: {},
    modules: {}
})
